/*** HOME Made By ES ***/
// @ts-nocheck
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import Parallax from 'parallax-js'

import AOS from 'aos';
import 'aos/dist/aos.css';
import { gsap } from 'gsap';
import SplitText from "../components/splitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const page = async () => {
    console.log('homee');
    
    AOS.init({
        once: true
    });

    loadAnimation()
 /*    const homeSwiper = new Swiper('#homeSlider', {
        modules: [Navigation],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    }) */
 /*    const homeSwiper = new Swiper('.swiperRegister', {
        modules: [Pagination, Autoplay],
        loop: true,
        autoplay: {
            delay: 4500,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
    }) */

    splitText();
}

const loadAnimation = () => {
    // Banner Section
    animateBannerSection()

    // Recipe Section
    animateRecipeSection()
  //  var sceneHome = document.querySelector(".mxmhboxTrivia__icon");
    // new Parallax(sceneHome);
}

const animateBannerSection = () => {
    let refSection: HTMLElement = document.querySelector('.mxmh-banner-home')
    refSection.classList.add('mxmh-banner-home--hide')

    const tl = gsap.timeline()
    tl.to(".mxmh-banner-home__textbox__title", { duration: 1, stagger: .2, translateY: 0, opacity: 1 })

}

const animateRecipeSection = () => {
    let refSection: HTMLElement | null = document.querySelector('.mxmh-recipes-home');
    
    if (refSection) {
        refSection.classList.add('mxmh-recipes-home--hide');
        
        gsap.to(".mxmh-banner-home__textbox__title", {
            duration: 1, translateY: 0, opacity: 1, stagger: .5,
            scrollTrigger: { trigger: ".mxmh-banner-home__textbox__title", start: "top 90%" }
        });
    }
}

//ANIMATION FOR TEXT
const splitText = () =>{
    gsap.registerPlugin(ScrollTrigger);


}